import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-login_code",
  "use": "icon-login_code-usage",
  "viewBox": "0 0 146 56",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 146 56\" id=\"icon-login_code\"><defs><style>#icon-login_code .a,#icon-login_code .c{fill:none;}#icon-login_code .a{stroke:#fc6e09;}#icon-login_code .b{stroke:none;}</style></defs><g class=\"a\"><rect class=\"b\" width=\"146\" height=\"56\" rx=\"11\" /><rect class=\"c\" x=\"0.5\" y=\"0.5\" width=\"145\" height=\"55\" rx=\"10.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol